import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import { service, serviceError } from '../../services/ajio'

import { useAuth } from 'src/hooks/auth'
import {
  BillIcon,
  Box,
  BoxButton,
  BoxInput,
  BoxText,
  Container,
  Content,
  ContentWrapper,
  InputWrapper,
} from './styles'

export type Billet = {
  status: string
  message: string
  barcode_details: {
    bank_code: string
    bank_name: string
    barcode: string
    digitable_line: string
    due_date: string
    value: number
    type: string
  }
  payment_info: {
    recipient_document: string
    recipient_name: string
    payer_document: string
    payer_name: string
    due_date: string
    limit_date: any
    min_value: number
    max_value: number
    fine_value: number
    interest_value: number
    original_value: number
    total_updated_value: number
    total_discount_value: number
    total_additional_value: number
  }
  transfeeraToken: string
}

export const PayBillsPayInvoice: React.FC = () => {
  const [barCode, setBarCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const { account } = useAuth()

  const navigation = useNavigate()
  const handleNextScreen = async () => {
    setLoading(true)
    setError('')

    try {
      const { data } = await service.post<Billet>('payments/validate', {
        barCode: barCode.replace(/[\s,-,/]/g, ''),
        accountId: account.virtual_account_id,
      })

      navigation('/paybills/info-invoice', {
        state: { ...data },
      })
    } catch (err) {
      setLoading(false)
      setError(serviceError(err).friend)
    }
  }

  return (
    <Container>
      <Content>
        <ContentWrapper>
          <Box>
            <BoxText>
              <h2>Realizar Pagamento de Boleto </h2>
              <span>Insira os dados do boleto</span>
            </BoxText>
            <BoxInput>
              <InputWrapper>
                <BillIcon />
                <input
                  type="text"
                  placeholder="Insira os dados do boleto"
                  value={barCode}
                  onChange={(input) => setBarCode(input.target.value)}
                />
              </InputWrapper>
              <BoxButton>
                <Button
                  handleFunction={handleNextScreen}
                  isLoading={loading}
                  title="Pagar"
                >
                  {/* <p>Pagar</p>
                  <ArrowRightIcon/> */}
                </Button>
              </BoxButton>
            </BoxInput>

            <BoxText>
              {error && <div className="block mt-3 text-red-500">{error}</div>}
            </BoxText>
          </Box>
        </ContentWrapper>
      </Content>
    </Container>
  )
}
